module.exports = __webpack_public_path__ + "img/1578927528.d89f8ed2.jpg";